import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "@/store";
import "./main.css";
import "./theme.css";
import "@vueform/multiselect/themes/default.css";
import {
  Button,
  ActionMenu,
  SegmentedButtons,
  TextButton,
} from "@/components/common";
import LayoutDashboard from "./layout/LayoutDashboard.vue";
import { setupAxiosInterceptors } from "@/config/axios-interceptor";
import Toast, { PluginOptions, POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { setupFilemanagerInterceptors } from "@/config/filemanager-interceptors";
import { setupNotificationInterceptors } from "@/config/notification-interceptors";
import { ObserveVisibility } from "vue-observe-visibility";
import { t } from "./i18n";
import { autoResize } from "@/directives/autoResize";
import { AuthGetters } from "@/store/modules/auth";
import { accountSessionMatches } from "@/utils/accountSession";

window.addEventListener("storage", (event) => {
  if (
    (event.key === "user" || event.key === null) &&
    !accountSessionMatches(store.getters[AuthGetters.GET_USER_IDENTITY])
  ) {
    window.location.replace("/login");
  }
});

const options: PluginOptions = {
  position: POSITION.TOP_RIGHT,
  hideProgressBar: true,
};

setupAxiosInterceptors(() => console.log("Un"));
setupFilemanagerInterceptors(() => console.log("Un"));
setupNotificationInterceptors(() => console.log("Un"));

const app = createApp(App);

app.config.globalProperties.$t = t;

app
  .component("layout-dashboard", LayoutDashboard)
  .component("Button", Button)
  .component("SegmentedButtons", SegmentedButtons)
  .component("ActionMenu", ActionMenu)
  .component("TextButton", TextButton)
  .component("Datepicker", Datepicker)
  .use(router)
  .use(store)
  .use(Toast, options)
  .directive("auto-resize", autoResize)
  .directive("observe-visibility", {
    beforeMount: (el, binding, vnode) => {
      (vnode as any).context = binding.instance;
      ObserveVisibility.bind(el, binding, vnode);
    },
    updated: ObserveVisibility.update,
    unmounted: ObserveVisibility.unbind,
  })
  .directive("click-outside", {
    beforeMount(el, binding, vnode) {
      el.clickOutsideEvent = function (event: Event) {
        if (!(el === event.target || el.contains(event.target))) {
          binding.value(event, el);
        }
      };
      document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted(el) {
      document.body.removeEventListener("click", el.clickOutsideEvent);
    },
  })
  .mount("#app");
